/**
 * SuggestedAIToolsLayout Component
 * Dedicated layout for Suggested AI Tools page
 * Clean layout with Header, Footer, and simple background
 */
import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';

export const SuggestedAIToolsLayout: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
        position: 'relative',
        overflow: 'hidden', // Prevent horizontal scroll only
        backgroundColor: 'transparent',
      }}
    >
      

      {/* Header with WHO branding and navigation */}
      <Header position="fixed" elevation={0} />

      {/* Main Content Area */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          paddingTop: { xs: '56px', sm: '64px', md: '72px' },
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Gradient Background - From Header to Explore Tools with fade-in from bottom */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            width: '100%',
            height: '960px',
            opacity: 0.4,
            background:
              'linear-gradient(67.52deg, rgba(122, 171, 255, 0.24) 13.64%, rgba(107, 93, 177, 0.24) 85.37%)',
            backdropFilter: 'blur(194px)',
            WebkitBackdropFilter: 'blur(194px)',
            // Fade-in mask from bottom to top
            maskImage:
              'linear-gradient(to top, transparent 0%, rgba(0, 0, 0, 0.3) 20%, rgba(0, 0, 0, 1) 100%)',
            WebkitMaskImage:
              'linear-gradient(to top, transparent 0%, rgba(0, 0, 0, 0.3) 20%, rgba(0, 0, 0, 1) 100%)',
            zIndex: 0,
            pointerEvents: 'none',
          }}
        />

        {/* Ellipse Background SVG - Extends across all sections */}
        <Box
          component="img"
          src="/assets/Ellipse%2011.svg"
          alt=""
          sx={{
            position: 'absolute',
            top: { xs: '-50px', md: '-100px', lg: '-150px' },
            left: { xs: '-100px', md: '-150px', lg: '-200px' },
            width: { xs: '600px', md: '800px', lg: '1000px' },
            height: 'auto',
            zIndex: 0,
            opacity: 1,
            pointerEvents: 'none',
            objectFit: 'contain',
          }}
        />

        {/* Page Content - Adjusts padding when desktop chatbot panel is open */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            position: 'relative',
            zIndex: 1,
            // Removed padding-right shift to prevent split-screen effect
            pr: 0,
          }}
        >
          {/* Page Content */}
          <Box
            component="main"
            sx={{
              flex: 1,
              position: 'relative',
            }}
          >
            <Outlet />
          </Box>

          {/* Footer */}
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

export default SuggestedAIToolsLayout;
